<template>
  <AdminJobList :hideProductFilters="true" :lockedFilters="{ MachineIdList: [$route.params.machineId] }">
  </AdminJobList>
</template>

<script>
import AdminJobList from "@/views/job/AdminJobList.vue";

export default {
  name: "ViewMachineJobs",
  props: {},
  components: {
    AdminJobList,
  },


  data() {
    return {};
  },

  mounted() { },

  methods: {},

  computed: {},

  watch: {},
};
</script>